export default __webpack_public_path__ + "static/media/8.6929c362.jpg";